import React, { useState, useEffect } from 'react';
import profile from '../../../assets/images/userInfoProfile.png';
import Header from './RightPanelHeader/Header';
import { CallWithAuth } from '../../../action/apiActions';
import { GET_QUESTIONBANK, GET_ORGANIZATION_DROPDOWNLIST } from '../../../action/apiPath';
import style from '../../../assets/styles/rightPanelStyle.module.css';
import { useNavigate } from 'react-router-dom';
import arrowIcon from '../../../assets/images/upArrow.svg';
// Interface for QuestionBank data
interface QuestionBankData {
  id: number;
  name: string;
}

// Interface for DataItem
interface DataItem {
  id: number;
  name: string;
}

interface OrgListItem {
  id: number;
  name: string;
}
interface RightPanelTopMenuProps {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-explicit-any
  setQuestionBankId: ((id: number) => void) | any;
  title: string;
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-explicit-any
  setOrganisationId?: (id: number) => void;
  showOrgDropdown?: boolean;
}
// API response interface
interface ApiResponse {
  status: boolean;
  res: {
    data: QuestionBankData[];
  };
}
const RightPanelTopMenu: React.FC<RightPanelTopMenuProps> = ({
  setQuestionBankId,
  title,
  setOrganisationId,
  showOrgDropdown,
}) => {
  // State with type definition
  const [questionBank, setQuestionBank] = useState<QuestionBankData[] | null>(null);
  const [orgList, setOrgList] = useState<OrgListItem[] | null>();
  const storedId = localStorage.getItem('selectedOrgId');
  const [currentOrgId, setCurrentOrgId] = useState<any>(storedId ? Number(storedId) : null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const Roles = userInfo.roles || [];
  const organizationId = userInfo.organization;
  const isSuperAdmin = Roles.some((role: { id: number; name: string }) => role.id === 1);
  const firstName = userInfo.first_name || '';
  const lastName = userInfo.last_name || '';
  const navigate = useNavigate();
  const getQuestionBank = async (): Promise<void> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const GetData: any | ApiResponse = await CallWithAuth('GET', GET_QUESTIONBANK + currentOrgId + '/');
    if (GetData?.status && Array.isArray(GetData?.res?.data)) {
      setQuestionBank(GetData.res.data);
      setQuestionBankId(GetData?.res?.data[0]?.id);
      localStorage.setItem('questionBankId', GetData.res.data[0].id);
    } else if (GetData?.res?.status === 400 && GetData.res.data.error[0] == 'No question banks found.') {
      setQuestionBank([]);
      setQuestionBankId('');
    }
  };

  // Update organization ID globally
  const updateOrgIdGlobally = (orgId: number) => {
    setCurrentOrgId(orgId);
    localStorage.setItem('selectedOrgId', String(orgId));
    setOrganisationId?.(orgId);

    window.dispatchEvent(new CustomEvent('organizationChanged', { detail: { organizationId: orgId } }));
  };

  // Fetch Organization List
  const getOrganizationList = async () => {
    const GetOrgData = await CallWithAuth('GET', GET_ORGANIZATION_DROPDOWNLIST);
    if (GetOrgData?.status && Array.isArray(GetOrgData?.res?.data)) {
      setOrgList(GetOrgData.res.data);

      // Set default org if none is selected
      if (!currentOrgId && GetOrgData.res.data.length > 0) {
        if (!organizationId) {
          const firstOrgId = Number(GetOrgData.res.data[0].id);
          setCurrentOrgId(firstOrgId);
          updateOrgIdGlobally(firstOrgId);
        } else {
          localStorage.setItem('selectedOrgId', String(organizationId));
          setCurrentOrgId(organizationId);
        }
      }
    }
  };

  useEffect(() => {
    if (isSuperAdmin && showOrgDropdown) {
      getOrganizationList();
    }

    const handleOrganizationChange = (e: CustomEvent) => {
      if (e.detail.organizationId !== currentOrgId) {
        setCurrentOrgId(e.detail.organizationId);
      }
    };

    window.addEventListener('organizationChanged', handleOrganizationChange as EventListener);

    return () => {
      window.removeEventListener('organizationChanged', handleOrganizationChange as EventListener);
    };
  }, [isSuperAdmin, currentOrgId]);
  useEffect(() => {
    if (!isSuperAdmin) {
      localStorage.setItem('selectedOrgId', String(organizationId));
      setCurrentOrgId(organizationId);
    }
  }, [isSuperAdmin, organizationId]);
  const handleOrgChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newOrgId = Number(e.target.value);
    updateOrgIdGlobally(newOrgId);
  };
  useEffect(() => {
    if (currentOrgId && setQuestionBankId) {
      getQuestionBank();
    }
  }, [currentOrgId]);

  const MasterData: DataItem[] = [
    {
      id: 1,
      name: 'Category',
    },
    {
      id: 2,
      name: 'Identifiers',
    },
    {
      id: 3,
      name: 'LOD',
    },
    {
      id: 4,
      name: 'Question Bank',
    },
    {
      id: 5,
      name: 'Subject Pipeline',
    },
  ];

  const ReportData: DataItem[] = [
    {
      id: 1,
      name: 'Question Distribution Report',
    },
    {
      id: 2,
      name: 'IRT parameters',
    },
  ];

  const handleViewProfile = (): void => {
    navigate('/user-management/user-details/' + userInfo.id);
  };

  return (
    <div>
      <div className={`${style.search_bar} ${style.show}`}>
        <div className={style.header}>
          {setQuestionBankId === null ? (
            <div className={style.header_text_title}>{title}</div>
          ) : (
            <Header
              questionBank={questionBank || []}
              ReportData={ReportData}
              MasterData={MasterData}
              setQuestionBankId={setQuestionBankId}
              title={title}
            />
          )}
        </div>

        <div className={style.profile}>
          {isSuperAdmin && orgList && showOrgDropdown && (
            <div className={style.organizationDrop}>
              <select
                name="organization"
                id="organization"
                className={style.organizationSelect}
                value={currentOrgId || ''}
                onChange={handleOrgChange}
              >
                {orgList?.map((items) => (
                  <option key={items.id} value={items.id}>
                    {items.name}
                  </option>
                ))}
              </select>
              <img src={arrowIcon} alt="Custom Arrow" className={style.dropdownSelectArrow} />
            </div>
          )}
          <div className={style.name}>
            <h4>
              {firstName} {lastName}
            </h4>
            <button className={style.viewProfileBtn} onClick={handleViewProfile}>
              view profile
            </button>
          </div>
          <div>
            <img src={profile} alt="Profile" width={48} height={48} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RightPanelTopMenu;
